import App from './App.svelte';
const app = new App({
	target: document.body,
	props: {
		name: 'hashsynth'
	}
});
export default app;

// import App from './App.svelte';

// import Content from './Content.svelte';
// const content = new Content({
// 	target: document.body,
// 	props: {
// 		name: 'ぽぽぽ'
// 	}
// });
// export default content;